import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import green from "@material-ui/core/colors/green";
import { useEffect, useState } from "react";
import {
  getCurrArchived,
  postCurrArchived,
} from "../../../../models/curriculum";
import Dialog from "./Dialog";

const useStyles = makeStyles(
  (theme: import("@material-ui/core/styles").Theme) => ({
    greenButton: {
      color: "white",
      backgroundColor: green[600],
      "&:hover": {
        backgroundColor: green[900],
      },
    },
  })
);

export default function Archive({ currCode }: { currCode: string }) {
  const classes = useStyles();

  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [isArchived, setIsArchived] = useState<boolean>();

  useEffect(() => {
    getCurrArchived(currCode).then(
      (res) => setIsArchived(res.isArchived),
      console.error
    );
  }, [currCode]);

  const handleClick = () => {
    setDialogOpen(true);
  };
  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleArchive = () => {
    postCurrArchived(currCode).then(() => {
      setIsArchived(true);
      setDialogOpen(false);
    }, console.error);
  };

  return (
    <>
      <Button
        className={classes.greenButton}
        color="inherit"
        variant="contained"
        disabled={isArchived}
        onClick={handleClick}
      >
        {isArchived ? "アーカイブ済み" : "アーカイブする"}
      </Button>
      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        onPublish={handleArchive}
      />
    </>
  );
}
